import type { Expense } from '@/types';

export const expenses: Expense[] = [
  {
    id: 'EX-2026-0011',
    date: '26 Ağustos 2026',
    category: 'Ekipman',
    amount: 4500,
    description: 'Yeni halı yıkama makinesi',
    jobId: '',
    team: '',
  },
  {
    id: 'EX-2026-0010',
    date: '25 Ağustos 2026',
    category: 'Temizlik Malzemesi',
    amount: 6200,
    description: 'Kimyasal ve bez stoğu',
    jobId: '',
    team: '',
  },
  {
    id: 'EX-2026-0009',
    date: '24 Ağustos 2026',
    category: 'Personel',
    amount: 18000,
    description: 'Ağustos ekip maaş avansı',
    jobId: '',
    team: 'A Ekibi',
  },
  {
    id: 'EX-2026-0008',
    date: '24 Ağustos 2026',
    category: 'Yakıt',
    amount: 3400,
    description: 'Ekip araçları yakıt',
    jobId: '',
    team: '',
  },
  {
    id: 'EX-2026-0007',
    date: '23 Ağustos 2026',
    category: 'Reklam',
    amount: 1800,
    description: 'Instagram reklam kampanyası',
    jobId: '',
    team: '',
  },
  {
    id: 'EX-2026-0006',
    date: '26 Ağustos 2026',
    category: 'Ulaşım',
    amount: 900,
    description: 'Köprü ve otopark giderleri',
    jobId: 'JOB-2026-0512',
    team: 'A Ekibi',
  },
  {
    id: 'EX-2026-0005',
    date: '22 Ağustos 2026',
    category: 'Ofis',
    amount: 1200,
    description: 'Ofis kırtasiye ve sarf malzeme',
    jobId: '',
    team: '',
  },
];